import {BaseDomainModel} from "../../../../infrastructure/models/base-domain-model";
import {RoundFilterApiModel} from "./round-filter.api-model";

export class RoundFilterDomainModel extends BaseDomainModel {
  apiModel: RoundFilterApiModel;

  get title(): String {
    return this.apiModel.title;
  }

  get key(): String {
    return this.apiModel.key;
  }

  get isCurrent(): Boolean {
    return this.apiModel.isCurrent;
  }
}
